import { IconProps } from "./types";

const QuestionIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/faq.svg" alt="" />;
};

export default QuestionIcon;
